import { useState } from 'react';
import { TextInput } from '@components/General/TextInput';
import { designSystem } from '@styles/designSystem';
import { VerticalContainer, VerticalSpacer } from '@components/General/Containers';
import { H1Title, H2Title, Subtitle } from '@components/General/Titles';

const TextInputShowcaseScreen = () => {
    const [basicValue, setBasicValue] = useState('');
    const [withPlaceholder, setWithPlaceholder] = useState('');
    const [withError, setWithError] = useState('');
    const [emailValue, setEmailValue] = useState('');
    const [emailError, setEmailError] = useState('');
    const [multilineValue, setMultilineValue] = useState('');
    const [loading, setLoading] = useState(false);
    const [charCount, setCharCount] = useState('');

    // Email validation
    const handleEmailChange = (value: string) => {
        setEmailValue(value);
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (value && !emailRegex.test(value)) {
            setEmailError('Please enter a valid email address');
        } else {
            setEmailError('');
        }
    };

    // Simulate loading
    const handleLoadingDemo = () => {
        setLoading(true);
        setTimeout(() => setLoading(false), 3000);
    };

    // Character counter
    const handleCharCountChange = (value: string) => {
        setCharCount(value);
    };

    return (
        <VerticalContainer>
            {/* Header */}
            <VerticalContainer gap={designSystem.gapNone}>
                <H1Title text={"TextInput component showcase"}/>
                <Subtitle text={"Various states and use cases for the TextInput component"}/>
            </VerticalContainer>
            <VerticalSpacer/>

        </VerticalContainer>
    );
};

export default TextInputShowcaseScreen;